export const FLEXI_LOAN_DE_URL =
  'https://static.iwoca.com/pdf/de/Broker-60m-500k.pdf';
